module.exports = __webpack_public_path__ + "img/tiktok_3938055.47da337e.png";